
require('jquery');
require('jquery-ui-bundle');
require('jquery-ui-timepicker-addon');

require('lodash');

require('dropzone');


// =======================
//  General
// =======================

$(document).ready( function() {


    // Datepickers
    

    $('.datepicker').datepicker({
        dateFormat: 'dd-mm-yy',
        maxDate: new Date()
    });

    $('.timepicker').timepicker();


    // Popups / Modals

    $('a[data-reveal-id]').click( function () {
        $('.bg-shade').fadeIn('fast');
        var id = $(this).attr('data-reveal-id');
        $('#' + id).css({opacity: 1, visibility: 'visible', top: '145px' }).fadeIn('fast');
        window.scrollTo(0, 0);
        return false;
    });

    $('.js-close-reveal-modal, .bg-shade').click( function() {
        $('.bg-shade').fadeOut('fast');
        $('.reveal-modal').fadeOut('fast');
    });

    $('.js-delete-monitor').click( function() {
        $('#delete-monitor-modal input[name="id"]').val( $(this).attr('data-id') );
    });

    $('.js-delete-site').click( function() {
        $('#delete-site-modal input[name="id"]').val( $(this).attr('data-id') );
    });

    $('.js-delete-visit').click( function() {
        $('#delete-visit-modal input[name="id"]').val( $(this).attr('data-id') );
    });

    $('.js-delete-ndd').click( function() {
        $('#delete-ndd-modal input[name="id"]').val( $(this).attr('data-id') );
    });

    $('.js-delete-lrd').click( function() {
        $('#delete-lrd-modal input[name="id"]').val( $(this).attr('data-id') );
    });


    // 'Show Password?' Checkboxes

    $('.js-add-monitor-show-password').click( function() {
        if ($(this).is(':checked')) {
            $('input[type=password]').attr('type', 'text').addClass('changed-password-field');
        } else {
            $('.changed-password-field').attr('type', 'password').removeClass('changed-password-field');
        }
    });

    $('.js-remove-spaces').change( function() {
        var original = $(this).val();
        $(this).val(original.replace(/\s/g, ''))
    });


    // NDD - File Upload

    Dropzone.autoDiscover = false;

    var form,
        uploadedFiles = [],
        filesInTransit = 0;

    var files = $('input[name=files]');
    if (files.length) {
        var existing = files.val();
        if (existing.length) {
            var existingFiles = JSON.parse(existing);
            $.each(existingFiles, function (i, val) {
                uploadedFiles.push(val);
            });
        }
    }

    var dropzoneEl = $("#myDropzone");

    if (dropzoneEl.length > 0) {

        function generateStorageName(file) {
            // Timestamp
            var date = Math.floor(Date.now() / 1000);
            // Rand Num (just in case)
            var rand = parseInt(Math.random() * 100);
            // Original name
            var name = file.name.replace(/ /g, "-");
            // All together
            return 'ndd-' + date + '-(' + rand + ')-' + name;
        }

        Dropzone.options.myDropzone = {
            maxFilesize: 8,
            acceptedFiles: 'image/*, .doc, .docx, .pdf, .odt',
            dictDefaultMessage: "Drop files here or &nbsp;&nbsp; <a href='#!' class='button small no-margin'>choose a file</a>",
            init: function () {

                this.on("sending", function(file, xhr, formData) {
                    // Set upload key
                    form.find('input[name="key"]').val(generateStorageName(file));

                    // Pause on exit
                    filesInTransit++;
                    window.onbeforeunload = function () {
                        return 'Your pictures are currently uploading...';
                    };

                    // Expand Space
                    $('.dropzone-to-go-here').height(220);
                });

                this.on("success", function (file, response) {
                    // Save S3 filename
                    var xml = $(response);
                    var s3Key = xml.find('Key').text();
                    uploadedFiles.push({
                        original_name: s3Key.substr(15),
                        storage_name: s3Key
                    });

                    // Remove pause on exit
                    filesInTransit--;
                    if (filesInTransit === 0) {
                        window.onbeforeunload = null;
                    }
                });
            }
        };

        form = dropzoneEl.addClass('dropzone').dropzone();

        $('.ndd-form').on('submit', function () {
            var files = JSON.stringify(uploadedFiles);
            $('input[name=files]').val(files);
        });

        function moveDrop() {
            var dropArea = $('.dropzone'),
                goHere = $('.dropzone-to-go-here');
            var pos = goHere.offset();
            dropArea.css({top: (pos.top - 270) + "px"});
            goHere.css({height: (dropArea.height() + 80) + 'px'});
        }

        $(window).resize(function () {
            moveDrop();
        });

        // Delay the movement so the page has loaded
        setTimeout(function () {
            moveDrop();
        }, 200);

    }

    //

    $('#habitat').change( function() {
        showHideHabitat();
    });

    function showHideHabitat() {
        if ($('#habitat').val() === "Other (note in comment)") {
            $('.habitat_other_area').show();
        } else {
            $('.habitat_other_area').hide();
        }
    }

    showHideHabitat();


});


// =======================
//  Vue
// =======================

import Vue from 'vue';


// Figure 1.16 - Create Visit

if ($('#vue-app-list').length) {
    new Vue({
        el: '#vue-app-list',
        data: {
            boxes: []
        },
        created: function () {
            var self = this;
            if (window.old) {
                // Edit or Validation Failed
                var original = window.old.list_boxes_with_nests;
                for (var item in original) {
                    self.boxes.push({number: original[item]})
                }
            }
            if (self.boxes.length === 0) {
                self.boxes.push({number: ""})
            }
        },
        methods: {
            addItem: function () {
                this.boxes.push({number: ""})
            },
            removeItem: function (index) {
                this.boxes.splice(index, 1);
            }
        }
    });
}


// Figure 1.17 - Record Dormice

if ($('#vue-app-dormice').length) {
    new Vue({
        el: '#vue-app-dormice',
        data: {
            boxes: []
        },
        created: function () {
            var self = this;
            if (window.old) {
                // Edit or Validation Failed
                var original = window.old.box;
                for (var item in original) {
                    self.boxes.push({
                        number: original[item].number,
                        inspected_h: original[item].inspected_h,
                        inspected_m: original[item].inspected_m,
                        found: original[item].found || original[item].mice.length,
                        dormice: original[item].mice || []
                    })
                }
            }
            if (self.boxes.length === 0) {
                self.boxes.push({
                    number: "",
                    inspected_h: "00",
                    inspected_m: "00",
                    found: 0,
                    dormice: []
                })
            }
        },
        methods: {
            addBox: function () {
                this.boxes.push({
                    number: "",
                    inspected_h: "00",
                    inspected_m: "00",
                    found: 0,
                    dormice: []
                });
                Vue.nextTick( function () {
                    $('.timepicker:not(.hasDatepicker)').timepicker();
                });
            },
            removeBox: function (index) {
                this.boxes.splice(index, 1);
            },
            addDormouse: function (index) {
                this.boxes[index].found++;
                this.boxes[index].dormice.push({
                    gender_id: 3,
                    weight: '',
                    state_id: 2,
                    breeding_id: 6, // unknown
                    young_id: 7, // unknown
                    comments: ''
                });
            },
            removeDormouse: function (index, innerIndex) {
                this.boxes[index].found--;
                this.boxes[index].dormice.splice(innerIndex, 1);
            },
            updateDormice: function (index, box) {
                if (!$.isNumeric(box.found)) {
                    return;
                }
                var i;
                var diff = box.found - box.dormice.length;
                if (diff > 0) {
                    // Add to List
                    for (i = 0; i < diff; i++) {
                        this.addDormouse(index);
                    }
                } else if (diff < 0) {
                    // Remove from List
                    diff = diff * -1;
                    for (i = 0; i < diff; i++) {
                        var itemToRemove = (box.dormice.length - i) - 1;
                        this.removeDormouse(index, itemToRemove);
                    }
                }
                // reset the num back to length (needed to prevent model binding)
                box.found = box.dormice.length;
            },
            inputName: function (index, suffix) {
                return 'box[' + index + ']' + suffix;
            },
            innerInputName: function (index, innerIndex, name) {
                return this.inputName(index, '[mice][' + innerIndex + '][' + name + ']');
            }
        }
    });


    // Using the timepicker and clicking 'done' won't change the model's inspected time.
    // Because of this, we periodically update it manually.

    // setInterval( function() {
    //     var timepickers = $('.timepicker.hasDatepicker');
    //     timepickers.each( function(i, val) {
    //         dormiceVue.boxes[i].inspected = $(val).val();
    //     });
    // }, 800);
}


// Figure 1.17 - Record Dormice

if ($('#vue-app-mammals').length) {
    new Vue({
        el: '#vue-app-mammals',
        data: {
            boxes: []
        },
        created: function() {
            var self = this;
            if (window.old) {
                var original = window.old.box;
                for (var item in original) {
                    self.boxes.push({
                        number: original[item].number,
                        found: original[item].found || original[item].animals.length,
                        mammals: original[item].animals || []
                    })
                }
            }
            if (self.boxes.length === 0) {
                self.boxes.push({
                    number: "",
                    found: 0,
                    mammals: []
                })
            }
        },
        methods: {
            addBox: function () {
                this.boxes.push({
                    number: "",
                    found: 0,
                    mammals: []
                })
            },
            removeBox: function (index) {
                this.boxes.splice(index, 1);
            },
            addMammal: function (index) {
                this.boxes[index].found++;
                this.boxes[index].mammals.push({
                    species_id: 1,
                    custom_species: '',
                    gender_id: 3,
                    weight: '',
                    breeding_id: 6, // unknown
                    comments: ''
                });
            },
            removeMammal: function (index, innerIndex) {
                this.boxes[index].found--;
                this.boxes[index].mammals.splice(innerIndex, 1);
            },
            updateMammals: function (index, box) {
                if (!$.isNumeric(box.found)) {
                    return;
                }
                var i;
                var diff = box.found - box.mammals.length;
                if (diff > 0) {
                    // Add to List
                    for (i = 0; i < diff; i++) {
                        this.addMammal(index);
                    }
                } else if (diff < 0) {
                    // Remove from List
                    diff = diff * -1;
                    for (i = 0; i < diff; i++) {
                        var itemToRemove = (box.mammals.length - i) - 1;
                        this.removeMammal(index, itemToRemove);
                    }
                }
                // reset the num back to length (needed to prevent model binding)
                box.found = box.mammals.length;
            },
            inputName: function (index, suffix) {
                return 'box[' + index + ']' + suffix;
            },
            innerInputName: function (index, innerIndex, name) {
                return this.inputName(index, '[animals][' + innerIndex + '][' + name + ']');
            }
        }
    });
}


// Figure 1.3 - Add Monitor

if ($('#vue-app-add-monitor').length) {
    var v = new Vue({
        el: '#vue-app-add-monitor',
        data: {
            original: [],
            sites: [],
            query: '',
            user: null
        },
        created: function () {
            var self = this;

            setTimeout(function() {
                var userID = (self.user !== null ? '/' + self.user.id : '');
                $.getJSON('/admin/monitors/sites' + userID + '?v=2', function (response) {
                    // If the validation fails - pre fill the site list with the last status
                    if (window.old && window.old.sites) {
                        for (var i=0; i<response.length; i++) {
                            if (window.old.sites.indexOf(response[i].id.toString()) >= 0) {
                                response[i].is_checked = true;
                            }
                        }
                    }
                    self.original = response;
                    self.sites = response;
                });
            }, 200);

            if (window.old && window.old.user) {
                this.user = window.old.user;
            }
        },
        methods: {
            search: function () {
                var self = this;
                self.sites = self.original.filter( function(item) {
                    return item.name.toLowerCase().indexOf(self.query.toLowerCase()) > -1
                });
            },
            formSubmit: function () {
                this.query = '';
                this.search();
                this.$nextTick( function() {
                    $('#vue-app-add-monitor form').submit();
                });
            }
        }
    });
}

// Reassign Site

if ($('#vue-app-reassign-site').length) {
    new Vue({
        el: '#vue-app-reassign-site',
        data: {
            original: [],
            users: [],
            query: '',
            site: null
        },
        created: function () {
            var self = this;
            self.site = window.site;
            $.getJSON('/admin/sites/' + self.site.id + '/monitors', function (response) {
                self.original = response;

                $.each(self.original, function(i, val) {
                    if (window.users.indexOf(val.id) >= 0) {
                        self.original[i].is_checked = true;
                    } else {
                        self.original[i].is_checked = false;
                    }
                });

                self.users = self.original;
            });
        },
        methods: {
            search: function () {
                var self = this;
                self.users = self.original.filter(function (item) {
                    return item.username.toLowerCase().indexOf(self.query.toLowerCase()) > -1
                });
            }
        }
    });
}


// Figure 1.22 - Licence Return Data

if ($('#vue-app-licence-return').length) {
    var lrdVue = new Vue({
        el: '#vue-app-licence-return',
        data: {
            sites: []
        },
        created: function () {
            if (window.old && typeof window.old.sites != 'undefined') {

                console.log(window.old);

                // Set null or missing values to '' to show the please select msg.
                var sites = window.old.sites;
                for(var i=0;i<sites.length;i++) {

                    console.log(sites[i].comments);

                    if (typeof sites[i].county_id == 'undefined' || sites[i].county_id === null) {
                        sites[i].county_id = '';
                    }
                    if (typeof sites[i].is_ndmp_site == 'undefined' || sites[i].is_ndmp_site === null) {
                        sites[i].is_ndmp_site = '';
                    }
                    for (var k=0; k<sites[i].visits.length; k++) {
                        var elements = [
                            'with_evidence',
                            'marked_as_moved',
                            'num_marked',
                            'num_moved',
                            'num_translocated',
                            'num_taken_into_captivity',
                            'num_handled_or_trapped',
                            'num_disturbed'
                        ];
                        for (var j=0; j<elements.length;j++) {
                            if (typeof sites[i].visits[k][elements[j]] == 'undefined' || sites[i].visits[k][elements[j]] === null) {
                                sites[i].visits[k][elements[j]] = '';
                            }
                        }

                        sites[i].visits[k].nest_in_box = false;
                        sites[i].visits[k].nest_in_tube = false;
                        sites[i].visits[k].natural_nest = false;
                        sites[i].visits[k].chewed_hazelnut = false;

                        if (typeof sites[i].visits[k].indirect_signs != 'undefined') {
                            if (sites[i].visits[k].indirect_signs.indexOf('nest in box') >= 0) {
                                sites[i].visits[k].nest_in_box = true;
                            }
                            if (sites[i].visits[k].indirect_signs.indexOf('nest in tube') >= 0) {
                                sites[i].visits[k].nest_in_tube = true;
                            }
                            if (sites[i].visits[k].indirect_signs.indexOf('natural nest') >= 0) {
                                sites[i].visits[k].natural_nest = true;
                            }
                            if (sites[i].visits[k].indirect_signs.indexOf('chewed hazelnut') >= 0) {
                                sites[i].visits[k].chewed_hazelnut = true;
                            }
                        }
                    }
                }
                window.old.sites = sites;

                this.sites = (window.old.sites === null ? [] : window.old.sites);

            } else {
                this.addSite();
            }
        },
        methods: {
            addSite: function() {
                this.sites.push({
                    id: null,
                    grid_ref: "",
                    site_name: "",
                    county_id: "",
                    is_ndmp_site: "",
                    visits: [this.createVisit()]
                });
                Vue.nextTick( function () {
                    $('.datepicker').datepicker("destroy");
                    $('.datepicker').removeClass('hasDatepicker');
                    $('.datepicker').datepicker({
                        dateFormat: 'dd-mm-yy'
                    });
                });
            },
            removeSite: function(index) {
                this.sites.splice(index, 1);
            },
            addVisit: function(site) {
                site.visits.push(this.createVisit());
                Vue.nextTick( function () {
                    $('.datepicker').datepicker("destroy");
                    $('.datepicker').removeClass('hasDatepicker');
                    $('.datepicker').datepicker({
                        dateFormat: 'dd-mm-yy'
                    });
                });
            },
            createVisit: function() {
                return {
                    id: null,
                    date: '',
                    with_evidence: '',
                    marked_as_moved: '',
                    num_handled_or_trapped: "",
                    num_disturbed: "",
                    marked_as_move: "",
                    num_marked: "",
                    num_moved: "",
                    num_translocated: "",
                    new_location_grid_reference: '',
                    num_taken_into_captivity: "",
                    nest_in_box: false,
                    nest_in_tube: false,
                    natural_nest: false,
                    chewed_hazelnut: false,
                    comments: ''
                };
            },
            removeVisit: function(siteIndex, visitIndex) {
                this.sites[siteIndex].visits.splice(visitIndex, 1);
            },
            inputName: function(index, suffix) {
                return 'sites[' + index + '][' + suffix + ']';
            },
            inputInnerName: function(index, innerIndex, suffix) {
                return this.inputInnerNameRaw(index, innerIndex, '[' + suffix + ']')
            },
            inputInnerNameRaw: function(index, innerIndex, suffix) {
                return 'sites[' + index + '][visits][' + innerIndex + ']' + suffix;
            },
            removeSpaces: function(site) {
                site.grid_ref = site.grid_ref.replace(/\s/g, '')
            }
        }
    });

    setInterval( function() {
        var timepickers = $('.datepicker.hasDatepicker');
        timepickers.each(function (i, val) {
            var input = $(val);
            var siteI = input.attr('data-site');
            var visitI = input.attr('data-visit');
            lrdVue.sites[siteI].visits[visitI].date = input.val();
        });
    }, 1000);
}